import {CodeListRef} from 'schemas/references';
import type {CodeList} from '../types';
import {sortByList} from './sortByList';

export const sortCodeList = (codelist: CodeList): CodeList => {
  switch (codelist.id) {
    case 'WORK_ROLE_TYPE':
      return sortWorkRoleType(codelist);
    case 'EXPRESSION_ROLE_TYPE':
      return sortExpressionRoleType(codelist);
    default:
      return codelist;
  }
};

const sortWorkRoleType = (codelist: CodeList): CodeList =>
  sortByList(codelist, [
    CodeListRef.WORK_ROLE_TYPE['Forfatter'],
    CodeListRef.WORK_ROLE_TYPE['Billedkunstner'],
    CodeListRef.WORK_ROLE_TYPE['Fotograf'],
    CodeListRef.WORK_ROLE_TYPE['Redaktør'],
  ]);

const sortExpressionRoleType = (codelist: CodeList): CodeList =>
  sortByList(codelist, [
    CodeListRef.EXPRESSION_ROLE_TYPE['Forfatter'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Illustrert av'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Fotografier av'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Oversatt av'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Innleser'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Redaktør'],
    CodeListRef.EXPRESSION_ROLE_TYPE['Omslag av'],
  ]);
